

/**
 * 定义用到的 event
 */
const definedEvents = [
  'view_item',
  'select_content',
  'view_item_list',
  'articles_goodslist_click',
  'articles_goods_click'
];

export default definedEvents;

export function check(name) {
  if (definedEvents.indexOf(name) === -1) {
    // eslint-disable-next-line
    console.error(`未定义 gtag event: ${name}`);
    return false;
  }
  return true;
}
